<script>

export default {

    props: {
        acceptFiles: {
            type: Array,
            default: () => { return [] }
        },

        allowedExtensions: {
            type: Array,
            default: () => { return [] }
        },

        callback: {
            type: Function,
            required: true
        },

        maxUploads: {
            type: Number,
            default: 5
        },

        url: {
            type: String,
            default: '/uploads'
        },

        sizeLimit: {
            type: Number,
            default: 500000000
        },

        totalUploads: {
            type: Number,
            required: true
        },

        query: {
            type: String
        }
    },

    data: function () {
        return {
            dropzone: null,
            error: null,
            uploader: null,
            uploads: [],
        }
    },

    mounted: function () {
        this.$nextTick(function () {
            let self = this

            this.uploader = new qq.FineUploaderBasic({
                debug: false,

                multiple: false,

                button: document.getElementById('uploadButton'),

                deleteFile: {
                    enabled: false,
                },

                chunking: {
                    enabled: true,
                    partSize: 5242880, // S3 chunk size requirement
                    paramNames: {
                        chunkSize: 'file_part_size',
                        partByteOffset: 'file_part_byte_offset',
                        partIndex: 'file_part_index',
                        totalParts: 'file_total_parts',
                    },
                    success: {
                        endpoint: this.url + '/success'
                    }
                },

                retry: {
                    enableAuto: true
                },

                request: {
                    endpoint: this.url,
                    filenameParam: 'file_name',
                    inputName: 'file_data',
                    uuidName: 'file_uuid',
                    totalFileSizeName: 'file_total_size',
                    customHeaders: {
                        'X-CSRF-TOKEN': window.Labstack.csrf_token
                    }
                },

                validation: {
                    acceptFiles: this.acceptFiles,
                    allowedExtensions: this.allowedExtensions,
                    sizeLimit: this.sizeLimit
                },

                callbacks: {
                    onSubmitted: function (id, name) {
                        self.uploads.push({
                            id: id,
                            name: name,
                            progress: 0
                        })
                    },

                    onError: function(id, name, errorReason, xhr) {
                        self.error = errorReason

                        self.clearUpload(id)
                    },

                    onProgress: function (id, name, uploadedBytes, totalBytes) {
                        let progress = Math.floor((uploadedBytes / totalBytes) * 100);

                        let upload = self.uploads.find(
                            u => u.id == id
                        )

                        upload.progress = progress
                    },

                    onComplete: function (id, name, responseJSON, xhr) {
                        self.error = null

                        self.clearUpload(id)

                        self.callback()
                    }
                }
            })

            this.dropzone = new qq.DragAndDrop({
                dropZoneElements: [document.getElementById('vue-labstack')],

                allowMultipleItems: false,

                classes: {
                    dropActive: "active"
                },

                callbacks: {
                    processingDroppedFilesComplete: function(files, dropTarget) {
                        self.uploader.addFiles(files);
                    }
                }
            })

        })
    },

    destroyed () {
        this.stopHandler();
    },

    methods: {
        clearUpload: function (id) {
            let index = this.uploads.findIndex(
                u => u.id == id
            )

            this.uploads.splice(index, 1)
        },

        cancelUpload: function (event, id) {
            let self = this

            let uuid = this.uploader.getUuid(id)

            this.uploader.cancel(id)

            axios.delete(this.url + '/' + uuid).then(
                function (response) {
                    // success callback
                    self.clearUpload(id)
                },
                function (response) {
                    // error callback
                    console.log('Connection Error')
                })
        },
    }
}

</script>
